import { render, staticRenderFns } from "./ObjectView.vue?vue&type=template&id=41f6401c&scoped=true"
import script from "./ObjectView.vue?vue&type=script&lang=js"
export * from "./ObjectView.vue?vue&type=script&lang=js"
import style0 from "./ObjectView.vue?vue&type=style&index=0&id=41f6401c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f6401c",
  null
  
)

export default component.exports